module.exports = __webpack_public_path__ + "static/media/Vector-8.f9d752eb.svg";